import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '@/mixpanel';
import { useAuth } from '@/context/AuthProvider';

export function usePageViewTracking() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Wait for user to be authenticated before tracking page view to prevent duplicate events.
    if (isAuthenticated) {
      const search = location.search || '';
      trackPageView(location.pathname, search, window.location.href);
    }
  }, [location.pathname, location.search, isAuthenticated]);
}
